import React from 'react';
import { useTransformPlaybookContext } from 'app/context/transform-playbook-context';
import GatedInputEventEditor from 'app/shared/components/testing-suite/GatedInputEventEditor';

export default function InputEditor() {
  const { input, setInput, setHasValidInput } = useTransformPlaybookContext();
  return (
    <GatedInputEventEditor
      defaultValue={input}
      setValue={setInput}
      setHasValidInput={setHasValidInput}
      trackingEventName="input_event_edited"
    />
  );
}
